export default __webpack_public_path__ + "static/media/regulatory--parking-fee-station--g1.70710155.png";